<template>
  <div style="padding: 20px;">
    <h3 @click="check">放养信息</h3>
    <template>
      <tabs 
        :list="aquaticLineFishStockingInfoDetails" 
        listField="aquaticLineFishStockingInfoDetails" 
        :head="stockHead"
        columnsField="stockingInfoColumns"
        dateField="stockingDate"
        costField="stocking"
        varietyType='varietyVisible'
      />
    </template>
    <br><br>
    <h3>用料信息</h3>
    <a-row :gutter="24">
      <a-col :span="24">
        <a-table 
          :columns="feedInfoFishColumns" 
          :data-source="allList" 
          :pagination="false"
        >
          <span slot="feedBrandTitle"><span style="color: red">*</span> 饲料品牌</span>
          <span slot="feedBrand" slot-scope="text, record">
            <a-select v-if="record.feedBrand != '总计' && record.feedBrand != '添加'"
              style="width: 66.66%;"
              placeholder="请选择"
              v-model="record.feedBrand"
              @change="handleChange"
            >
              <a-select-option v-for="el in feedBrandList" :key="el.varietyDepotCode" :value="el.varietyDepotName">
                {{ el.varietyDepotName}}
              </a-select-option>
            </a-select>
            <a-button 
              style="width: 100%;"
              v-if="record.feedBrand == '添加'" type="dashed" @click="addFeedInfo"
            >+继续添加用料信息</a-button>
            <span style="font-size: 14px ;margin: 20px;font-weight: bold;" v-if="record.feedBrand == '总计'">总计</span>
          </span>
          <span slot="productNameTitle"><span style="color: red">*</span> 产品名称</span>
            <span slot="productName" slot-scope="text, record, index">
              <a v-if="record.feedBrand == '总计' || record.feedBrand == '添加'" ></a>
              <a v-else-if="record.feedBrand == '新希望' && !record.productName" 
                @click="handleClick(index)"
              >选择配方</a>
              <a v-else-if="record.feedBrand == '新希望' && record.productName" 
                @click="handleClick(index)"
              >{{record.productName}}</a>
              <a-input v-else style="width: 66.66%" placeholder="请输入" v-model="record.productName" :maxLength="50"/>
              <a-button v-if="record.feedBrand == '新希望' && record.productName" 
                style="margin-left: 10px" 
                @click="deleteProductName(record)"
              >删除</a-button>
            </span>
            <span slot="feedTerminalPriceTitle"><span style="color: red">*</span> 饲料终端价格（元/吨）</span>
            <span slot="feedTerminalPrice" slot-scope="text, record">
              <a-input-number
                v-if="record.feedBrand != '总计' && record.feedBrand != '添加'"
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="100000"
                v-model="record.feedTerminalPrice"
                :precision="2"
              />
              <span v-else style="font-size: 14px;font-weight: bold;">{{ record.feedTerminalPrice }}</span>
            </span>
            <span slot="feedCostTitle"><span style="color: red">*</span> 总耗料量（吨）</span>
            <span slot="feedCost" slot-scope="text, record">
              <a-input-number 
                v-if="record.feedBrand != '总计' && record.feedBrand != '添加'"
                style="width: 66.66%;"
                placeholder="请输入"
                :min="1"
                :max="100000"
                v-model="record.feedCost"
                :precision="2"
              />
              <span v-else style="font-size: 14px;font-weight: bold;">{{ record.feedCost }}</span>
            </span>
          <span slot="x" slot-scope="text, record,index">
            <a v-if="record.feedBrand != '总计' && record.feedBrand != '添加'" @click="deleteFeedInfo(index)">删除</a>
          </span>
        </a-table>
        <br><br><br>
      </a-col>
    </a-row>
    <formula-modal 
      ref="formulaModal" 
      :visible="visible" 
      @isShow="isShow" 
      @getSelect="getSelect" 
      :selectFactory="selectFactory"
      :factoryId="factoryId"
    />
  </div>
</template>

<script>
import {feedInfoFishColumns} from '../Columns'
import FormulaModal from './FormulaModal'
import { mapMutations,mapState } from 'vuex';
import Tabs from './Tabs.vue';

export default {
  props:['selectFactory','factoryId','feedVarietyList'],
  components:{FormulaModal,
    Tabs
  },
  data(){
    return{
      numbers: ['一','二','三','四','五','六','七','八','九',],
      hideAdd: false,
      activeKey: 0,
      feedInfoFishColumns,
      feedInfoList:[],
      form: this.$form.createForm(this, { name: 'feedInfo' }),
      feedBrandList:[],
      visible: false,
      len: 2,
      stockHead: {
        dateTitle: '选择放养日期',
        dateField: 'stockingDate',
        varietyTitle: '选择放养品种',
      }
    }
  },
  computed: {
    ...mapState('empirical',[
      'varietyVisible',
      'varietySelect',
      'aquaticLineFishStockingInfoDetails',
      'tabKey',
      'aquaticLineFishStockingInfo',
      'aquaticLineFishFeedInfos',
      'varietyDate',
    ]),
    last(){
      let feedTerminalPrice = 0,feedCost = 0
      this.feedInfoList.forEach(el => {
        // feedTerminalPrice += Number(el.feedTerminalPrice || 0)
        feedTerminalPrice += (Number(el.feedTerminalPrice || 0) * Number(el.feedCost || 0))
        feedCost += Number(el.feedCost || 0)
      })
      feedTerminalPrice = feedTerminalPrice.toFixed(this.len)
      feedCost = feedCost.toFixed(this.len)
      return {feedBrand:'总计',feedTerminalPrice,feedCost}
    },
    allList(){
      let add = {feedBrand:'添加',}
      return this.feedInfoList.length >= 5 ? [...this.feedInfoList,this.last] : [...this.feedInfoList,add,this.last]
    }
  },
  watch: {
    varietyVisible(val){
      if(!val){
        if(!this.aquaticLineFishStockingInfoDetails[this.tabKey]) this.aquaticLineFishStockingInfoDetails[this.tabKey] = {}
        this.aquaticLineFishStockingInfoDetails[this.tabKey].details = this.varietySelect
        this.aquaticLineFishStockingInfoDetails[this.tabKey].stockingDate= this.varietyDate
        this.setState({aquaticLineFishStockingInfoDetails: [...this.aquaticLineFishStockingInfoDetails]})
      }
    },
    aquaticLineFishStockingInfoDetails: {
      handler(data){
        this.calStocking(data)
      },
      deep: true
    },
    feedInfoList: {
      handler(aquaticLineFishFeedInfos){
        this.setState({aquaticLineFishFeedInfos})
      },
      deep: true,
    },
  },
  mounted() {
    this.feedBrandGet()
    if(this.$route.query.copyId) this.convert()
    this.form.setFieldsValue(this.pigLineFeedInfo)
    this.feedInfoList = [...this.aquaticLineFishFeedInfos]
  },
  methods:{
    ...mapMutations('empirical',['setState']),
    calStocking(data){
      let lst = []
        data.forEach(el => {
          if(el) lst = [...lst,...el.details]
        })
        let totalStockingNum = 0, // 合计放养数量
        totalStockingWeight = 0, // 合计放养重量
        // totalStockingVarietyNum = 0, // 合计放养品种数
        // eatFoodVarietyNum = 0, // 吃食鱼放养品种数
        eatFoodNum = 0, // 吃食鱼放养数
        eatFoodWeight = 0, // 吃食鱼放养重量
        // filterFoodVarietyNum = 0, // 滤食鱼放养品种数
        filterFoodNum = 0, // 滤食鱼放养数
        filterFoodWeight = 0, // 滤食鱼放养重量
        varietyIdArr = [],
        csVarietyIdArr = [],
        lsVarietyIdArr = []
        lst.forEach(el => {
          totalStockingNum += Number(el.stockingNum || 0)
          totalStockingWeight += Number(el.stockingWeight || 0)
          if(!varietyIdArr.includes(el.varietyId)) varietyIdArr.push(el.varietyId)
          if(el.varietyLabelCode === 'chishi') {
            if(!csVarietyIdArr.includes(el.varietyId)) csVarietyIdArr.push(el.varietyId)
            eatFoodNum += Number(el.stockingNum || 0)
            eatFoodWeight += Number(el.stockingWeight || 0)
          }
          if(el.varietyLabelCode === 'lvshi') {
            if(!lsVarietyIdArr.includes(el.varietyId)) lsVarietyIdArr.push(el.varietyId)
            filterFoodNum += Number(el.stockingNum || 0)
            filterFoodWeight += Number(el.stockingWeight || 0)
          }
        })
        this.aquaticLineFishStockingInfo.stockingTimes = data.length
        this.aquaticLineFishStockingInfo.totalStockingNum = totalStockingNum.toFixed(0)
        this.aquaticLineFishStockingInfo.totalStockingWeight = totalStockingWeight.toFixed(this.len)
        this.aquaticLineFishStockingInfo.totalStockingVarietyNum = varietyIdArr.length
        this.aquaticLineFishStockingInfo.eatFoodVarietyNum = csVarietyIdArr.length
        this.aquaticLineFishStockingInfo.eatFoodNum = eatFoodNum.toFixed(0)
        this.aquaticLineFishStockingInfo.eatFoodWeight = eatFoodWeight.toFixed(this.len)
        this.aquaticLineFishStockingInfo.filterFoodVarietyNum = lsVarietyIdArr.length
        this.aquaticLineFishStockingInfo.filterFoodNum = filterFoodNum.toFixed(0)
        this.aquaticLineFishStockingInfo.filterFoodWeight = filterFoodWeight.toFixed(this.len)
        this.setState({aquaticLineFishStockingInfo: this.aquaticLineFishStockingInfo})
    },
    check(){},
    tabTitle(i){
      return `第${this.numbers[i]}次`
    },
    onEdit(targetKey, action) {
      this[action](targetKey);
    },
    remove(targetKey){
      this.$confirm({
        title: '提示信息',
        content: '信息删除后无法恢复，确认删除本次信息吗？',
        cancelText:'取消',
        okText:'确定',
        onOk:()=>{
          let i = this.panes.findIndex(el => el.key === targetKey)
          this.activeKey = i - 1
          this.panes.splice(i,1)
        }
      })
    },
    // 新增用料信息
    addFeedInfo(){
      this.feedInfoList.push({
        feedBrand:'',
        productName:'',
        feedTerminalPrice:'',
        feedCost:'',
        nhfFormulaId :'',
        modelCode : '',
        modelName : ''
      })
    },
    // 删除用料信息
    deleteFeedInfo(index){
      this.feedInfoList.splice(index,1);
    },
    // 将饲养信息传送到父组件
    sendData(){
      this.$emit('setFeedInfo', {feedInfoList:this.feedInfoList})
    },
    handleChange(){

    },
    handleClick(index) {
      this.visible = true
      this.$refs.formulaModal.reset()
      this.$refs.formulaModal.initRecord(index)
    },
    isShow(val){
      this.visible = val
    },
    // 获取已选择配方信息
    getSelect(val,index){
      this.feedInfoList[index].productName = val[0].formulaName;
      this.feedInfoList[index].nhfFormulaId = val[0].id
      this.feedInfoList[index].modelCode = val[0].modelCode
      this.feedInfoList[index].modelName = val[0].modelName
    },
    // 获取饲料品牌
    async feedBrandGet() {
      const res = await this.$http.get("/sat-ruminants/varietydepot/list", { params:{type:2, size:-1, labelCode:'Aquatic'} })
      let { success, data } = res
      if (success) this.feedBrandList = data.records 
    },
    convert(){
      
    },
    verificationLegal() {
      if(this.feedInfoList){
        // this.$message.error('请输入！')
      }
    },
    // 清除已选择配方
    deleteProductName(record){
      record.productName = undefined
      record.nhfFormulaId = ''
      record.modelCode = ''
      record.modelName = ''
    }
  }
}
</script>

<style>

</style>